import { useEffect } from "react";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore TS7019:
const api: Horta = (...args) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TS2339:)
  (api.q = api.q || []).push(args);
};

globalThis._horta = api;

export function useJobDispatch(): void {
  useEffect(() => {
    const heads = document.getElementsByTagName("head");
    if (heads.length) {
      const script = document.createElement("script");
      script.id = "_horta";
      script.src = "https://d4mjspzk6ii2q.cloudfront.net/widget.js";
      script.async = true;

      heads[0].appendChild(script);
      _horta("init", {
        companyName: "Fiberplane",
        ATSIdentifier: "fiberplane",
      });
    }
  }, []);
}
